// data/projectSlugs.js
export default [
  'bathroom-remodeling-in-los-angeles-ca-90069',
  'modern-spanish-style-kitchen-remodeling-in-corona-92883',
  'modern-outdoor-living-with-pergola-remodel-in-santa-monica-90402',
  'modern-master-bedroom-remodeling-in-bel-air-los-angeles-90077',
  'high-end-bathroom-remodeling-in-pacific-palisades-90272',
  'high-end-outdoor-living-renovation-in-holmby-hills-los-angeles-90024',
  'luxury-pool-spa-artificial-turf-hardscaping-in-porter-ranch-ca-91326',
  'luxury-kitchen-renovation-in-encino-los-angeles-91316',
  'modern-front-yard-pavers-and-artificial-turf-in-toluca-lake-ca-91602',
  // Add more project folder names here
];
